import React from 'react';
import ModalForm from '../components/Modal/ModalForm';
import InputsSection from '../components/Modal/InputsSectionColumn';
import InputBoxSkeleton from './InputBoxSkeleton';
import ModalButtonsSkeleton from './ModalButtonsSkeleton';
import SkeletonStyles from './Skeletons.module.css';

const DeleteModalSkeleton = () => {
  return (
    <ModalForm style={{ marginBottom: '2.5rem' }}>
      <InputsSection>
        <InputBoxSkeleton />
        <div className='flexCol'>
          <div className={[SkeletonStyles.form_input__text, SkeletonStyles.skeleton].join(' ')} style={{ width: '30rem' }} />
          <div className={[SkeletonStyles.form_input__text, SkeletonStyles.skeleton].join(' ')} />
        </div>
      </InputsSection>
      <InputsSection>
        <div className='flexCol'>
          <div className={[SkeletonStyles.form_input__text, SkeletonStyles.skeleton].join(' ')} style={{ width: '30rem' }} />
          <div className={[SkeletonStyles.form_input__text, SkeletonStyles.skeleton].join(' ')} />
          <div className={[SkeletonStyles.form_input__text, SkeletonStyles.skeleton].join(' ')} style={{ width: '10rem' }} />
        </div>
      </InputsSection>
      <ModalButtonsSkeleton />
    </ModalForm>
  );
};

export default DeleteModalSkeleton;
